(function () {
    'use strict';

    angular
        .module('campaignMgmtRoutes', ['oddRoutes', 'campaignStatusMgmtModule'])
        .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {

        $stateProvider

            // External Parties
            .state('odd.campaignStatusMgmt', {
                url: '/ExternalParty',
                views: {
                    'externalParties': {
                        controller: 'ODDExternalPartiesController',
                        templateUrl: require('./externalParties.tpl.html')
                    }
                }
            });
         
    }
})();